import { Component, OnInit, EventEmitter, Input, Output } from '@angular/core';
import { CompleterService, CompleterData, CompleterItem } from 'ng2-completer';
import {AutoCompleteModule} from 'primeng/primeng';
import {CUIFeatureInterface} from  '../../interfaces/cui-feature.interface';


//MM Bug 136925
//Replaced the 3rd party ng-completer control.. with PrimeNG's AutoComplete. 
//PrimeNG's AutoComplete control provides the same functionality, and keeps the dropdown visually connected to the text box, even when scrolling.

@Component({
    selector: 'cui-autocomplete',
   // template: '<ng2-completer [(ngModel)]="_text" [dataService]="_dataService" [minSearchLength]="0" (selected) = "OnSelected($event)"></ng2-completer>',
    template: '<p-autoComplete [(ngModel)]="_text" [suggestions]="_suggestions" [minLength]="0" (onSelect)= "OnSelected($event)"  (completeMethod)= "search($event)" ></p-autoComplete>'//,
    //styleUrls: ['./app/shared/cui-autocomplete/cui-autocomplete.component.css']
})
export class CUIAutoCompleteComponent implements CUIFeatureInterface {
    //@Input() ngModel: string = 'No items found.';
    @Input() data: any[];
    @Input() dataField: string;
    @Output() selected: EventEmitter<any> = new EventEmitter();
    private _dataService : CompleterData;
    private _text: string;
    private _suggestions: any[];

    
    constructor (
        private _completerService: CompleterService
    )
    {}

    //ngOnChanges() {   };
    ngOnInit(){  };
    ngDoCheck() {   };
    ngAfterContentInit() {   };
    ngAfterContentChecked() {  };
    ngAfterViewInit() {   };
    ngAfterViewChecked() {  };
    ngOnDestroy() {   };

    ngOnChanges(): void {
        this._dataService = this._completerService.local(this.data, this.dataField, this.dataField); 
        this._suggestions = this.getFields(this.data, this.dataField, this.dataField);
    }

    private getFields(list, field, otherwise) {
            //  map the provided list to an array containing either the requested field or the alternative value
            return list.map(function (item) {
                    //  If item is an object and contains the field, add its value and the value of otherwise if not
                    return typeof item === 'object' && field in item ? item[field] : otherwise;
                }, []);
    }
    
    private OnSelected(event) {

        let result = this.data.filter(function (obj) {
            return (obj["name"].toUpperCase().indexOf(event.toUpperCase())>=0);
        })[0];

        console.debug("CUIAutoCompleteComponent.OnSelected() event:");
        console.debug(event);
        if (this.selected)
            this.selected.emit(result);
    }


    private search(event) { 

        let result = this.data.filter(function (obj) {
            return (obj["name"].toUpperCase().indexOf(event.query.toUpperCase()) >= 0);
        });
        this._suggestions = this.getFields(result, this.dataField, this.dataField);
       
        

    }

}



// WEBPACK FOOTER //
// C:/WS/Fusion/FusionDashboard/src/app/shared/cui-autocomplete/cui-autocomplete.component.ts